import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { StatsComponent } from '../players/stats/stats.component';
import { HistoryComponent } from '../players/history/history.component';
import { SummaryComponent } from '../players/summary/summary.component';
import { BaseTableComponent } from '../base/base-table/base-table.component';

@Component({
  selector: 'app-players',
  templateUrl: './players.component.html',
  styleUrls: ['./players.component.css', './../base/base-table/base-table.component.css']
})
export class PlayersComponent extends BaseTableComponent implements OnInit {
  infos: Observable<any[]>;
  playerId: number = 1;
  playerInfo;
  isGoalie: boolean = false;
  summaryActive: boolean = true;
  statsActive: boolean = false;
  historyActive: boolean = false;

  constructor(private firestore: AngularFirestore, private route: ActivatedRoute) {
    super();
  }
  @ViewChild(SummaryComponent, { static: false }) summaryComponent: SummaryComponent;
  @ViewChild(StatsComponent, { static: false }) statsComponent: StatsComponent;
  @ViewChild(HistoryComponent, { static: false }) historyComponent: HistoryComponent;

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.playerId = parseInt(params.id);
      this.infos = this.firestore.collection('players', ref => ref.where('ID', '==', this.playerId)).valueChanges();
      this.infos.forEach(val => {
        this.isGoalie = (val[0]["Position"] == 'G') ? true : false;
      });
    });
  }

  setActive(page: string) {
    this.summaryActive = (page == "summary") ? true : false;
    this.statsActive = (page == "stats") ? true : false;
    this.historyActive = (page == "history") ? true : false;
  }
}
